import React from "react";
import { Button, Callout, Intent, Spinner } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import styles from "./SyncSchedulePanel.module.scss";

interface ILoadingStateProps {
  loaded: boolean;
  loading: boolean;
  error: string | null;
  onLoadData: () => void;
}

const LoadingState: React.FC<ILoadingStateProps> = ({
  loaded,
  loading,
  error,
  onLoadData
}) => {
  if (!loaded) {
    return (
      <div>
        <Button
          intent={Intent.PRIMARY}
          icon={IconNames.ARROW_RIGHT}
          style={{margin: "20px 0"}}
          onClick={onLoadData}
          loading={loading}
        >
          Load Sync Schedule(s)
        </Button>
        {error && (
          <Callout intent={Intent.DANGER} icon={IconNames.ERROR} style={{ marginTop: '1em' }}>
            {error}
          </Callout>
        )}
      </div>
    );
  }

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner />
        <div className={styles.loadingText}>Loading sync schedule...</div>
      </div>
    );
  }

  if (error) {
    return (
      <Callout intent={Intent.DANGER} icon={IconNames.ERROR}>
        {error}
      </Callout>
    );
  }

  return null;
};

export default LoadingState;
